/**
 * emailRule — WEB-1716: ОДНА точка правды «что считается почтой» в рантайме
 * квиза. До карточки правил было два: гейт «Обязательное» считал заполненной
 * любую непустую строку (requiredGate.isFilled), а лид писался только при
 * совпадении с образцом (emailLookup.EMAIL_REGEX). Между ними была дыра:
 * покупатель с `ivan@mail` спокойно уходил дальше без единой ошибки, а лид не
 * создавался вообще — клик куплен, квиз пройден, контакта нет.
 *
 * Правило намеренно совпадает с прежним образцом emailLookup (поведение на
 * стороне создания лида не меняется ни на йоту): непустая часть до @, непустой
 * домен с точкой, никаких пробелов и второй собаки. Строже (проверка домена,
 * подсказки опечаток вроде gmail.con) сюда не кладём: отбить настоящий адрес
 * покупателя дороже, чем пропустить экзотический.
 *
 * ⚠ Кто добавляет ещё одно место, где решается «это почта?», обязан звать
 * ЭТУ функцию, а не копировать регулярку — расхождение копий и есть баг
 * WEB-1716.
 */

/** Образец адреса: `что-то@что-то.что-то` без пробелов и лишних собак. */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Значение поля в том виде, в каком его сравнивают и отправляют (без краёв). */
export function normalizeEmail(raw: string | undefined | null): string {
  return typeof raw === 'string' ? raw.trim() : '';
}

/** Похоже ли введённое на почту. Пустое — не похоже. */
export function isValidEmail(raw: string | undefined | null): boolean {
  const value = normalizeEmail(raw);
  return value.length > 0 && EMAIL_PATTERN.test(value);
}
